import createSvgIcon from './utils/createSvgIcon'

export default createSvgIcon('lightning-bolt')
